import { render, staticRenderFns } from "./ApplicationsTable.vue?vue&type=template&id=64ad1f89&"
import script from "./ApplicationsTable.vue?vue&type=script&lang=js&"
export * from "./ApplicationsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports